import {observer} from 'mobx-react';
import DashboardCreateForm from '../components/DashboardCreateForm';

export default observer(function DashboardCreate() {

    return (
        <DashboardCreateForm/>
    );
});
